import { useState } from 'react';
import { useAuth } from '../Components/context/Auth';
import { getAPIData } from '../Utils/commonApi';
import useUserActions from './actions/user.hooks';

const useTakeControlAccessSession = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { authTokens } = useAuth();
  const { initiateSession } = useUserActions();

  const takeControl = ({ customerId, accessSessionId }) => {
    return new Promise((resolve) => {
      setIsLoading(true);
      getAPIData(`${11}`, authTokens, {
        optionEnum1: accessSessionId,
        impersonateOrgId: customerId
      })
        .then((response) => {
          if (response?.Success) {
            initiateSession()
            .then((response) => {
              if (response?.sessionUrl) {
                window.open(
                  `${process.env.REACT_APP_DEVUI_URL}/login/session-access?callbackAPI=${encodeURIComponent(response.sessionUrl)}`,
                  '_blank',
                  'width=1280,height=720,incognito=yes'
                );
              }
            }).finally(() => {
              setIsLoading(false);
              resolve();
            })
          }
        })
        .catch(() => {
          setIsLoading(false);
          resolve();
        })
    });
  }

  return {
    isLoading,
    takeControl
  }
}

export default useTakeControlAccessSession;
